// extracted by mini-css-extract-plugin
export var bounce = "_jr-1";
export var generatingText = "_jr-6";
export var lightning = "_jr-4";
export var popup = "_jr-5";
export var progressBar = "_jr-7";
export var progressFill = "_jr-8";
export var progressShimmer = "_jr-9";
export var progressText = "_jr-a";
export var shimmer = "_jr-3";
export var uploadIcon = "_jr-0";
export var uploadingText = "_jr-2";